import { ProductionRequest } from './production-request';

export enum ProductionOrderStatusEnum {
  PENDING = 'pending',
  COMPLETED = 'completed',
  ON_HOLD = 'on-hold',
  ARCHIVED = 'archived',
}

export const ProductionOrderStatusColorMap: Record<ProductionOrderStatusEnum, string> = {
  'on-hold': 'red',
  completed: 'green',
  archived: 'gray',
  pending: 'gray',
};

export type CustomizationAttribute = string | number | boolean;

export type ProductionOrderMetadata = Record<string, CustomizationAttribute> & {
  origin: string;
};

export type ProductionOrder = {
  id: string;
  trackingNumber: string;
  status: ProductionOrderStatusEnum;
  metadata: ProductionOrderMetadata;
  content: ProductionRequest[];
  createdAt: string;
  updatedAt: string;
};
